import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export default function SiteFooter() {
  return (
    <footer className="bg-neutral-950 text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <Brand size="md" variant="dark" />
          <p className="mt-6 text-sm text-neutral-400 max-w-sm leading-relaxed">
            A premium payroll servicing partner, run under Harguon Enterprises.
            GSTIN 06ATUPP9372R1Z9. Serving clients across India.
          </p>
        </div>
        <div className="text-sm font-mono text-neutral-400">
          <div className="text-[#D4B87D] uppercase tracking-widest text-[10px] mb-3">Site</div>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-[#C9A961] transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#C9A961] transition-colors">Services</Link></li>
            <li><Link to="/about" className="hover:text-[#C9A961] transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#C9A961] transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div className="text-sm font-mono text-neutral-400">
          <div className="text-[#D4B87D] uppercase tracking-widest text-[10px] mb-3">Reach us</div>
          <ul className="space-y-2">
            <li><a href="tel:+919355653653" className="hover:text-[#C9A961] transition-colors">+91 93556 53653</a></li>
            <li><a href="mailto:contact@harguonservices.com" className="hover:text-[#C9A961] transition-colors break-all">contact@harguonservices.com</a></li>
            <li className="pt-4 text-[10px] uppercase tracking-widest text-neutral-500">Mon – Sat · 10:00 – 19:00 IST</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-3 text-[10px] font-mono uppercase tracking-widest text-neutral-500">
          <span>© 2026 HG Consultancy · Harguaon Group</span>
          <span>Est. Harguaon Group · India · FY 2025-26 compliant</span>
        </div>
      </div>
    </footer>
  );
}
